<mat-dialog-content style="max-height: 567px">
  <ng-container>
      <div class="content-confirm" align="center">
          <div class="py-3">{{ data.title }}</div>
          <p>{{ data.subtitle }}</p>
          <mat-icon class="icon" [svgIcon]="data.icon"></mat-icon>
      </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center">
<div class="content-btn">
  <button
    mat-stroked-button
    class="me-3 cancel"
    (click)="onNoClick()"
    id="on-cancel"
  >
    <span>Cancelar</span>
  </button>
  <button
    mat-flat-button
    class="button-success"
    (click)="emitEvent()"
    id="submit"
  >
    <span>Aceptar</span>
  </button>
</div>
</mat-dialog-actions>
<button mat-button mat-dialog-close class="dialog-close" id="close-icon-dialog">
<mat-icon>close</mat-icon>
</button>
